type SpinnerSize = 'sm' | 'md' | 'lg';

interface SpinnerProps {
  size?: SpinnerSize;
  label?: string;
}

export function Spinner({ size = 'sm', label }: SpinnerProps) {
  if (label) {
    return (
      <output className="spinner-wrap">
        <span className={`spinner spinner--${size}`} aria-hidden="true" />
        <span className="visually-hidden">{label}</span>
      </output>
    );
  }
  return <span className={`spinner spinner--${size}`} aria-hidden="true" />;
}
